import _ from "lodash";
import moment from "moment/moment";

export const entity = {
    name: 'Function',
    facets: [{name: 'codeName', uniqueName: true}],
    fields: [
        {path: 'status', type: 'Status'}
    ],
    filters: [
        {
            name: 'byStatus',
            path: "status",
            object: "Status",
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const status = _.get(context, 'data.status.id');
                return status ? {status: status} : {};
            }
        }
    ]
}

export const module_ = {
    object: 'Function',
    category: {
        path: 'configuration',
        icon: 'settings'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: ['code', 'name', {path: 'status', initiallyNotVisible: true}],
        form: [
            {path: 'code', placeholder: 'renseigner un code unique', noSpaces: true},
            {path: 'name', placeholder: 'renseigner un nom unique'},
            {path: 'status', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: ['byStatus']
}
